import {FormElement} from "./FormElement";
import {FormBuilder} from "../FormBuilder";
import {SchemaField} from "../../Infrastructure/Server/SchemaField";
const $ = jQuery;

// TODO add checkboxes to regions as well

export class CheckboxesFormElement extends FormElement {

    checkboxLabel: string;
    checkboxValue: string;

    constructor(options: SchemaField, formBuilder: FormBuilder, external: {[key: string]: any}) {
        super(options, formBuilder, external);

        this.db_type = 'text';
        this.checkboxLabel = options.checkboxLabel;

        this.setOptions(options.options);
    }

    setDomElements() {
        super.setDomElements();
    }

    setEventHandlers() {
        super.setEventHandlers();
        $(this.domElements.main).on('change', 'input', (e)=>{
            var a = [];
            $(this.domElements.main).find('input:checked').map((i, el)=>{ a.push(jQuery(el).attr('name')); });
            this.value = a;
            this.events.trigger('changed', this, [this]);
        });
    }

}